// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
    This file handle common CSS property for custom interface list view template
*/
.container-list-component {
  padding-right: 0;
}

.list-col-text {
  padding-left: 0;
}

.list-col-value {
  text-align: right;
  padding-right: 0;
}

.center-vertically-horizzontally {
  text-align: center;
}

.title-aggregate {
  text-align: center;
  margin-bottom: 10px;
}

::ng-deep .container-grid-button {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep .container-grid-button > * {
  flex: 1 1 auto;
  width: 20%;
}
::ng-deep .container-grid-button > *:nth-child(n+6) {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/theme/supervision-list-common.scss","webpack://./src/components/template%20component/two-or-more-buttons-template/two-or-more-buttons-template.component.scss","webpack://./src/components/template component/two-or-more-buttons-template/two-or-more-buttons-template.component.scss"],"names":[],"mappings":"AAAA;;CAAA;AAIA;EACI,gBAAA;ACAJ;;ADGA;EACI,eAAA;ACAJ;;ADGA;EACI,iBAAA;EACA,gBAAA;ACAJ;;ADGA;EACI,kBAAA;ACAJ;;AChBA;EACI,kBAAA;EACA,mBAAA;ADmBJ;;ACdI;EACI,aAAA;EACA,eAAA;ADiBR;ACfQ;EACI,cAAA;EACA,UAAA;ADiBZ;ACfY;EACI,gBAAA;ADiBhB","sourcesContent":["/**\n    This file handle common CSS property for custom interface list view template\n*/\n\n.container-list-component {\n    padding-right: 0;\n}\n\n.list-col-text{\n    padding-left: 0;\n}\n\n.list-col-value{\n    text-align: right; \n    padding-right: 0;\n} \n\n.center-vertically-horizzontally{\n    text-align: center;\n}","/**\n    This file handle common CSS property for custom interface list view template\n*/\n.container-list-component {\n  padding-right: 0;\n}\n\n.list-col-text {\n  padding-left: 0;\n}\n\n.list-col-value {\n  text-align: right;\n  padding-right: 0;\n}\n\n.center-vertically-horizzontally {\n  text-align: center;\n}\n\n.title-aggregate {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n::ng-deep .container-grid-button {\n  display: flex;\n  flex-wrap: wrap;\n}\n::ng-deep .container-grid-button > * {\n  flex: 1 1 auto;\n  width: 20%;\n}\n::ng-deep .container-grid-button > *:nth-child(n+6) {\n  margin-top: 10px;\n}","@use '../../../theme/supervision-list-common.scss';\n\n.title-aggregate{\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n\n::ng-deep {\n    .container-grid-button{\n        display: flex;\n        flex-wrap: wrap;\n    \n        & > * {\n            flex: 1 1 auto;\n            width: 20%;\n    \n            &:nth-child(n+6) {\n                margin-top: 10px;\n            }\n        }\n    } \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
